import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ListItem, ThemeProvider, Typography } from "@mui/material";
import { theme } from "components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper";
import { isNull, isUndefined } from "lodash";
import { AntSwitch, Dot } from "components/UI/CustomizedComponents/CustomizedComponents";

type CalendarNavItem = {
  color: string;
  children: CalendaSideBarNavigationInterface | null;
};

interface CalendaSideBarNavigationInterface {
  [index: string]: CalendarNavItem;
}

const CalendaSideBarNavigation: { [index: string]: CalendarNavItem } = {
  Meetings: {
    color: "#3174ad",
    children: {
      Draft: {
        color: "#6c757d",
        children: null,
      },
      Upcoming: {
        color: "#3174ad",
        children: null,
      },
      "Virtual/Hybrid": {
        color: "#17a2b8",
        children: null,
      },
      "In-progress": {
        color: "#dea704",
        children: null,
      },
      Postponed: {
        color: "#3174ad",
        children: null,
      },
      Completed: {
        color: "#21913c",
        children: null,
      },
      Cancelled: {
        color: "#c22f3d",
        children: null,
      },
    },
  },
  Evaluations: {
    color: "lightGrey",
    children: null,
  },
  Approvals: {
    color: "lightGrey",
    children: null,
  },
  Compliances: {
    color: "lightGrey",
    children: null,
  },
};

export default function FilterList() {
  const [openList, setOpenList] = React.useState(["Meetings"]);
  const handleOpen = (key: string) => {
    setOpenList((opened) => [...opened.filter((op) => op !== key), key]);
  };
  const handleClose = (key: string) => {
    setOpenList((opened) => [...opened.filter((op) => op !== key)]);
  };

  const renderMenuListRecursively = (
    menuItem: CalendaSideBarNavigationInterface
  ) => {
    return Object.entries(menuItem).map(([key, value], i) => {
      if (isNull(value.children) || isUndefined(value.children))
        return (
          <ListItem key={i + ":" + key}>
            <ListItemIcon>
              <Dot customColor={value.color} size="0.8em" />
              {/* <AntSwitch trackColor={value.color} sizeFactor={0.8} /> */}
            </ListItemIcon>
            <ListItemText primary={key} />
          </ListItem>
        );
      return (
        <>
          <ListItem key={i + ":" + key}>
            <ListItemIcon>
              <Dot customColor={value.color} size="0.8em" />
              {/* <AntSwitch trackColor={value.color} sizeFactor={0.8} /> */}
            </ListItemIcon>
            <ListItemText primary={key} />
            {openList.includes(i + ":" + key) ? (
              <ExpandLess onClick={() => handleClose(i + ":" + key)} />
            ) : (
              <ExpandMore onClick={() => handleOpen(i + ":" + key)} />
            )}
          </ListItem>
          <Collapse in={openList.includes(i + ":" + key)} unmountOnExit>
            <List
              component="div"
              disablePadding
              sx={{ pl: 2, bgcolor: "#7575750f" }}
            >
              {renderMenuListRecursively(value.children)}
            </List>
          </Collapse>
        </>
      );
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          height: '45vh',
          overflowY: 'auto',
          bgcolor: "background.paper",
          "& .MuiListItemText-primary": {
            fontSize: "0.98em",
          },
          px:1
        }}
        component="nav"
        aria-labelledby="nested-calendar-filter-subheader"
        subheader={
          <ListSubheader id="nested-list-subheader">
            <Typography textTransform="uppercase">Calendar Filters</Typography>  
          </ListSubheader>
        }
      >
        {renderMenuListRecursively(CalendaSideBarNavigation)}
      </List>
    </ThemeProvider>
  );
}
